module.exports = __webpack_public_path__ + "static/media/TrainingCenter.9df8e4f8.zip";